export default {
    searchQuery: state => state.searchQuery,
    existsFavProjectId: state => id => state.favorites.find((e) => e.ProjectID == id),
    projectList: (state, getters, rootState, rootGetters) => {
        const userInfo = rootGetters["auth/getUser"];

        return state.projects.filter(projectItem => {

            if (rootState.auth.isUserLoggedIn() && userInfo) {

                if (userInfo.AccountType == 2 || userInfo.AccountType == 3) {

                    return (projectItem.ShowStudent == true && (
                        (projectItem.ProjectName && projectItem.ProjectName.toString()
                            .toLowerCase()
                            .includes(state.searchQuery.toLowerCase())) ||
                        (projectItem.ProjectDesc && projectItem.ProjectDesc.toString()
                            .toLowerCase()
                            .includes(state.searchQuery.toLowerCase())) ||
                        (projectItem.ProjectDesc && projectItem.ProjectDesc.toString()
                            .toLowerCase()
                            .includes(state.searchQuery.toLowerCase())) ||
                        (projectItem.ProjectHtml && projectItem.ProjectHtml.toString()
                            .toLowerCase()
                            .includes(state.searchQuery.toLowerCase()))
                    ));
                }
                else
                    return (
                        (projectItem.ProjectName && projectItem.ProjectName.toString()
                            .toLowerCase()
                            .includes(state.searchQuery.toLowerCase())) ||
                        (projectItem.ProjectDesc && projectItem.ProjectDesc.toString()
                            .toLowerCase()
                            .includes(state.searchQuery.toLowerCase())) ||
                        (projectItem.ProjectDesc && projectItem.ProjectDesc.toString()
                            .toLowerCase()
                            .includes(state.searchQuery.toLowerCase())) ||
                        (projectItem.ProjectHtml && projectItem.ProjectHtml.toString()
                            .toLowerCase()
                            .includes(state.searchQuery.toLowerCase()))
                    );
            }
            else
                return [];
        }).slice().sort((x, y) => {
            const fav1 = getters.existsFavProjectId(x.ProjectID);
            const fav2 = getters.existsFavProjectId(y.ProjectID);
            return (fav1 && fav2 && x.Order - y.Order) ||
                (!fav1 && fav2 && 1) ||
                (fav1 && !fav2 && -1) ||
                x.Order - y.Order
        });
    }
};